import { Checkbox } from '@material-ui/core';
import CustomTextField from 'components/Input/CustomTextField';
import TipsIcon from 'components/TipsIcon';
import usePrevious from 'hooks/usePrevious';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { addRemoveRequest, deleteRemoveRequest, produce } from 'utility/general';

const SLayout = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;

const SRadioLayout = styled.div`
    display: flex;
    flex-shrink: 0;
    /* margin-left: 20px; */
    align-items: center;
    position: relative;
`;

const SDisplayLayout = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 5px;
    flex-shrink: 0;
`;

const CustomCheckbox = ({
    radioButton = false,
    defaultData = [
        {
            key: '',
            display: 'test',
            value: false,
            showRemarkInput: false,
            tooltip: 'test tooltip',
            debounceChange: false,
            remarkParams: { allowAction: true },
        },
    ],
    isRequired = false,
    isValidValue = (isValid) => null,
    onChange = (key, checked) => null,
    onItemChange = (key, checked) => null,
    allowMultipleSelect = false,
    allowUnCheckAll = false,
    disableOnPermission = false,
    remarkParams = [{ key: '', params: {} }],
    name = '',
    value = [],
    allowAction = true,
    updateApplicationFormOnDisableChange = -1,
    updateSiteFormOnDisableChange = -1, // site-info id
    onAppFieldValidate,
    disabled = false,
    forceErrorDisplay = false,
    isAllowChangeUnChecked,
    test,
}) => {
    const [componentValue, setComponentValue] = useState(defaultData);
    const previousDisable = usePrevious(`${allowAction}`);
    const previousValue = usePrevious(value);

    const checkAppFieldValidate = () => {
        if (onAppFieldValidate !== undefined) {
            const isDisabled = getDisableExceptionPermission();
            if (isDisabled) {
                onAppFieldValidate(name, true);
            } else {
                if (isValueExist()) {
                    onAppFieldValidate(name, true);
                } else {
                    onAppFieldValidate(name, false);
                }
            }
        }
    };

    useEffect(() => {
        // updateApplicationFormOnDisableChange = application id
        if (previousDisable && (updateApplicationFormOnDisableChange >= 0 || updateSiteFormOnDisableChange >= 0)) {
            if (!name) {
                throw new Error('name is required');
            }

            const isDisabled = getDisableExceptionPermission();
            if (isDisabled) {
                addRemoveRequest({
                    applicationFormId: updateApplicationFormOnDisableChange,
                    name: name,
                    siteInfoId: updateSiteFormOnDisableChange,
                });
            } else {
                deleteRemoveRequest({
                    applicationFormId: updateApplicationFormOnDisableChange,
                    keys: [name],
                    siteInfoId: updateSiteFormOnDisableChange,
                });
            }
        }

        checkAppFieldValidate();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allowAction, disabled]);

    // check if value exist
    const isValueExist = () => {
        let isExist = componentValue.some((item) => {
            return item.value === true;
        });

        if (!isExist) {
            isExist = defaultData.some((item) => {
                return value.includes(item.key);
            });
        }

        return isExist;
    };

    useEffect(() => {
        if (isRequired) {
            isValidValue(isValueExist());
        } else {
            isValidValue(true);
        }

        checkAppFieldValidate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [componentValue]);

    // reset component value if value changes to null
    useEffect(() => {
        // if (value?.[0] === null) {
        //     setComponentValue(defaultData);
        // }

        if (JSON.stringify(value) !== JSON.stringify(previousValue)) {
            const newData = produce(componentValue, (draft) => {
                if (value.includes(draft.key)) {
                    draft.value = true;
                } else {
                    draft.value = false;
                }
            });

            setComponentValue(newData);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const getDisableExceptionPermission = () => {
        if (disabled) {
            return true;
        }

        if (allowAction === false) {
            return true;
        }

        return false;
    };

    const getDisableStatus = () => {
        if (disableOnPermission) {
            return true;
        }

        if (disabled) {
            return true;
        }

        if (allowAction === false) {
            return true;
        }

        return false;
    };

    const onSelect = (e, item) => {
        const { checked } = e.target;
        const newData = produce(componentValue, (draft) => {
            if (radioButton) {
                draft.forEach((item) => {
                    item.value = false;
                });
            }

            const index = draft.findIndex((draftItem) => item.key === draftItem.key);
            draft[index].value = checked;
        });

        // if not allow un-check all selection
        if (!allowUnCheckAll && !isAllowChangeUnChecked) {
            const isAllUnChecked = newData.every((item) => !item.value);

            if (isAllUnChecked) {
                return;
            }
        }

        onChange(name, newData);
        onItemChange(item.key, e.target.checked);
        setComponentValue(newData);
    };

    return (
        <div>
            <SLayout>
                {componentValue.map((item, index) => {
                    const itemParams = remarkParams.find((inputItem) => {
                        return item.key.toString() === inputItem.key.toString();
                    });
                    const inputParams = itemParams?.params ?? {};
                    const SRadioLayoutStyle = itemParams?.SRadioLayoutStyle ?? {};
                    const SDisplayLayoutStyle = itemParams?.SDisplayLayoutStyle ?? {};
                    return (
                        <SRadioLayout key={item.key} style={{ ...SRadioLayoutStyle, marginLeft: index === 0 ? 0 : 20 }}>
                            <div style={{ position: 'relative' }}>
                                <Checkbox
                                    disabled={getDisableStatus()}
                                    style={{ padding: 0 }}
                                    checked={value.includes(item.key)}
                                    color={'primary'}
                                    onChange={(e) => {
                                        onSelect(e, item);
                                    }}
                                    size="small"
                                />
                                {getDisableStatus() && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            opacity: 0.5,
                                            transform: 'translate(-50%, -50%)',
                                            width: 12,
                                            height: 12,
                                            background: '#CAC0C0',
                                            cursor: 'not-allowed',
                                        }}
                                    />
                                )}
                            </div>

                            <SDisplayLayout style={SDisplayLayoutStyle}>{item.display}</SDisplayLayout>
                            {item.tooltip && <TipsIcon title={item.tooltip} />}
                            {item.showRemarkInput && <CustomTextField {...inputParams} />}
                        </SRadioLayout>
                    );
                })}
            </SLayout>
            {forceErrorDisplay && isRequired && !isValueExist() && (
                <div style={{ color: 'red', fontSize: 12, marginTop: 8, marginLeft: 12 }}>This field is required.</div>
            )}
        </div>
    );
};

export default CustomCheckbox;
